import { MtAccountPackage } from "server/models"
import { ThemeType, inferLiteral } from "client/utils"
import {
    AccountSettings,
    UserSettings,
    PackageSettings,
    PackageUsage,
} from "client/store"
import {
    AccountPermissions,
    ProjectPermissions,
    CommonPermissions,
} from "client/store/utils"
import * as types from "./types"


export const setSystemUserData = (userData: types.UserData) => ({
    type: inferLiteral(types.SYSTEM_USER_DATA),
    userData,
})
export const clearSystemUserData = () => ({
    type: inferLiteral(types.CLEAR_SYSTEM_USER_DATA),
})
export const setSystemUserGroups = (userGroups: readonly number[]) => ({
    type: inferLiteral(types.SYSTEM_USER_GROUPS),
    userGroups,
})
export const setSystemProjectUserGroups = (projectId: number, projectUserGroups: readonly number[]) => ({
    type: inferLiteral(types.SYSTEM_PROJECT_USER_GROUPS),
    projectId,
    projectUserGroups,
})


export const setSystemPackageActive = (activePackage: MtAccountPackage) => ({
    type: inferLiteral(types.SYSTEM_PACKAGE_ACTIVE),
    activePackage,
})
export const setSystemPackageSettings = (packageSettings: PackageSettings) => ({
    type: inferLiteral(types.SYSTEM_PACKAGE_SETTINGS),
    packageSettings,
})
export const setSystemPackageUsage = (packageUsage: PackageUsage) => ({
    type: inferLiteral(types.SYSTEM_PACKAGE_USAGE),
    packageUsage,
})
export const setSystemPackageUsageSilCalculations = (silCalculations: number) => ({
    type: inferLiteral(types.SYSTEM_PACKAGE_USAGE_SIL_CALCULATIONS),
    silCalculations,
})


export const setSystemAccountSettings = (settings: AccountSettings) => ({
    type: inferLiteral(types.SYSTEM_ACCOUNT_SETTINGS),
    settings,
})
export const setSystemUserSettings = (settings: UserSettings) => ({
    type: inferLiteral(types.SYSTEM_USER_SETTINGS),
    settings,
})


export const setSystemAccountPermissions = (accountPermissions: AccountPermissions) => ({
    type: inferLiteral(types.SYSTEM_ACCOUNT_PERMISSIONS),
    accountPermissions,
})
export const setSystemProjectPermissions = (projectId: number, projectPermissions: ProjectPermissions) => ({
    type: inferLiteral(types.SYSTEM_PROJECT_PERMISSIONS),
    projectId,
    projectPermissions,
})
export const setSystemLifecyclePermissions = (lifecyclePermissions: CommonPermissions) => ({
    type: inferLiteral(types.SYSTEM_LIFECYCLE_PERMISSIONS),
    lifecyclePermissions,
})


export const setSystemLostServerConnection = () => ({
    type: inferLiteral(types.SYSTEM_LOST_SERVER_CONNECTION),
})


export const setSystemTheme = (theme: ThemeType) => ({
    type: inferLiteral(types.SYSTEM_THEME),
    theme,
})
export const setSystemLang = (lang: types.LangType) => ({
    type: inferLiteral(types.SYSTEM_LANG),
    lang,
})
export const setSystemLangReport = (lang: types.LangType) => ({
    type: inferLiteral(types.SYSTEM_LANG_REPORT),
    lang,
})


export const setUrlOrigin = (value: string) => ({
    type: inferLiteral(types.URL_ORIGIN),
    value,
})
export const addModal = (params: types.ModalParams) => ({
    type: inferLiteral(types.ADD_MODAL),
    params,
})
export const closeModal = () => ({
    type: inferLiteral(types.CLOSE_MODAL),
})
export const updateModalUrl = (url: string) => ({
    type: inferLiteral(types.UPDATE_MODAL_URL),
    url,
})


export const renderContent = (value: boolean) => ({
    type: inferLiteral(types.RENDER_CONTENT),
    value,
})
export const renderProjectContent = (value: boolean) => ({
    type: inferLiteral(types.RENDER_PROJECT_CONTENT),
    value,
})
